var map = {
	"./tech-excel.svg": 2141,
	"./tech-git.svg": 2142,
	"./tech-google-sheets.svg": 2143,
	"./tech-gray-chatgpt.svg": 1154,
	"./tech-gray-excel.svg": 1155,
	"./tech-gray-git.svg": 1156,
	"./tech-gray-google-sheets.svg": 1157,
	"./tech-gray-jupyter.svg": 1158,
	"./tech-gray-multiple.svg": 1159,
	"./tech-gray-other.svg": 1160,
	"./tech-gray-powerbi.svg": 1161,
	"./tech-gray-python.svg": 1162,
	"./tech-gray-r.svg": 1163,
	"./tech-gray-sql.svg": 1164,
	"./tech-gray-tableau.svg": 1165,
	"./tech-gray-theory.svg": 1166,
	"./tech-powerbi.svg": 2144,
	"./tech-python (2).svg": 2145,
	"./tech-python.svg": 2146,
	"./tech-r.svg": 2147,
	"./tech-responsive-artificial-intelligence.svg": 526,
	"./tech-responsive-chatgpt.svg": 553,
	"./tech-responsive-data.svg": 554,
	"./tech-responsive-excel.svg": 555,
	"./tech-responsive-git.svg": 556,
	"./tech-responsive-google-sheets.svg": 557,
	"./tech-responsive-jupyter.svg": 558,
	"./tech-responsive-langchain.svg": 559,
	"./tech-responsive-multiple.svg": 560,
	"./tech-responsive-powerbi.svg": 561,
	"./tech-responsive-powerpoint.svg": 562,
	"./tech-responsive-python.svg": 563,
	"./tech-responsive-r.svg": 564,
	"./tech-responsive-sql.svg": 565,
	"./tech-responsive-tableau.svg": 566,
	"./tech-responsive-theory.svg": 567,
	"./tech-sql.svg": 2148,
	"./tech-tableau.svg": 2149,
	"./tech-theory.svg": 2150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3521;